import * as React from 'react';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';

const NotFound = (props) => {
	return (
		<div className="news listNews">
			<div className="container">
				<div className="row">
					<div className="col-md-12">
						<div className="wrap404">
							<div className="txt404 font2"> 404 </div>
							<p>
								{props.t('not_found')}<br/>
								Go to <Link to="/">home</Link>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default translate('translations')(NotFound);



// WEBPACK FOOTER //
// ./src/components/NotFound.tsx